// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.menu-avatar[data-v-41d6f4fc] {\n  width: 48px;\n  font-size: 20px;\n  font-weight: 700;\n  text-transform: uppercase;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n}\n.tile-menu-avatar[data-v-41d6f4fc] {\n  width: 48px;\n}\n.v-toolbar__content[data-v-41d6f4fc] {\n  padding: 0;\n}\n.v-avatar[data-v-41d6f4fc] {\n  width: 48px !important;\n}\n", ""]);
// Exports
module.exports = exports;
